module.exports = __webpack_public_path__ + "img/bg.e89c08c1.jpg";